import "./Reviews.css";

const Reviews = () => (
  <div className="max-w-2xl h-auto mx-auto relative mb-16">
    <div id="TA_selfserveprop753" className="TA_selfserveprop flex flex-col items-center justify-center">
      <ul id="4LYBFukIMaq" className="TA_links V5wBEKX2QMB">
        <li id="xnj3K6XbZA" className="O04DPosiPGXM">
          <a target="_blank" href="https://www.tripadvisor.com/Attraction_Review-g309293-d33097180-Reviews-Paticas_Travel-San_Jose_San_Jose_Metro_Province_of_San_Jose.html" rel="noreferrer">
            <img src="https://www.tripadvisor.com/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-11900-2.svg" alt="TripAdvisor" />
          </a>
        </li>
      </ul>
    </div>
  </div>
)

export default Reviews;
